export function getBorderWidth(transformer) {
    return Object.freeze({
        none: transformer.borderWidth('0'),
        normal: transformer.borderWidth('1px'),
        thick: transformer.borderWidth('2px'),
    });
}
